import React, {useEffect, useState, useCallback, useContext} from 'react';
import { Link } from 'react-router-dom';
import { Button, Box, Checkbox, TextField, FormControl, FormControlLabel } from '@mui/material';
import { useSnackbar } from 'notistack';

import envirolabLogo from 'resources/images/Envirolab-family-330x150.png';
import { AccessDataContext } from '../../../../contextProviders/AccessDataContext';
import { useValidation } from '../../../../hooks/UseValidation';
import { OverlayContext } from '../../../../contextProviders/OverlayContext';

const Register = () => {
  const {registerUser} = useContext(AccessDataContext);
  const { enqueueSnackbar } = useSnackbar();
  const {setShowLoadingOverlay} = useContext(OverlayContext);
  const {validateEmail, validatePassword} = useValidation();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [emailValid, setEmailValid] = useState(true);
  const [passwordValid, setPasswordValid] = useState(true);
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [registrationSuccessful, setRegistrationSuccessful] = useState(false);
  const [alreadyRegistered, setAlreadyRegistered] = useState(false);

  const handleTermsCheck = useCallback((item) => {
    setAcceptTerms(item.target.checked);
  }, []);

  const setErrorSnackbar = useCallback(
    (msg) => {
      enqueueSnackbar && enqueueSnackbar(msg || 'error', { variant: 'error' });
    },
    [enqueueSnackbar]
  );

  const submitRegistration = useCallback((e) => {
    e.preventDefault();
    const checkPassword = validatePassword(password);
    setPasswordValid(checkPassword);
    if (!emailValid || !passwordsMatch || !checkPassword){
      return;
    }
    setShowLoadingOverlay(true);
    const data = {
      FirstName: firstName,
      LastName: lastName,
      Email: email,
      Password: password,
      ConfirmPassword: confirmPassword,
      AcceptTerms: acceptTerms
    };
    registerUser(data).then((response) => {
      if(response?.message === "Success") {
        setRegistrationSuccessful(true);
      }
      else if (response?.message === "Email Registered"){
        setAlreadyRegistered(true);
      }
      else{
        setErrorSnackbar(response?.message);
      }
      setShowLoadingOverlay(false);
    })
  }, [password, firstName, lastName, email, registerUser, confirmPassword, acceptTerms, emailValid, validatePassword, passwordsMatch, setShowLoadingOverlay, setErrorSnackbar]);
  useEffect(() => {
    setPasswordsMatch(password === confirmPassword);
  }, [password, confirmPassword, setPasswordsMatch]);
  useEffect(() => {    
    setEmailValid(validateEmail(email));
  }, [email, validateEmail])
  useEffect(() => {
    if (!passwordValid) {
      setPasswordValid(validatePassword(password));
    }
  }, [password, validatePassword, passwordValid])
  return (
    <Box id="loginBox">
      <Box className="imageBox">
        <img alt="Envirolab logo" src={envirolabLogo} />
      </Box>

      {!registrationSuccessful ? <form onSubmit={submitRegistration}>
        <h1>Register New User</h1>
        <FormControl fullWidth>
          <TextField label="Firstname" name="firstName" onChange={(item) => setFirstName(item.target.value)} required />
        </FormControl>
        <FormControl fullWidth>
          <TextField label="Lastname" name="lastName" onChange={(item) => setLastName(item.target.value)} required />
        </FormControl>
        <FormControl fullWidth>
          <TextField label="Email" name="email" error={!emailValid} helperText={!emailValid ? "Email address is not valid" : ""} onChange={(item) => setEmail(item.target.value)} required />
        </FormControl>
        <FormControl fullWidth>
          <TextField label="Password" type="password" name="password" error={!passwordValid} helperText={!passwordValid ? "Minimum six characters, at least one uppercase letter, one lowercase letter and one number" : ""} onChange={(item) => setPassword(item.target.value)} required />
        </FormControl>     
        <FormControl fullWidth>
          <TextField label="Confirm Password" type="password" name="confirmPassword" error={!passwordsMatch} helperText={!passwordsMatch ? "Passwords do not match" : ""} onChange={(item) => setConfirmPassword(item.target.value)} required />
        </FormControl>     
        <FormControlLabel label="I agree with the terms and conditions" control={<Checkbox checked={acceptTerms} onChange={handleTermsCheck} required /> } />
        <Button className="siteBtn" type="submit" variant="outlined" size="large">Submit</Button>
      </form> : null }
      {registrationSuccessful ? <Box className="successBox">Registration succesful. Please check your email for verification and click <Link to="/">here</Link> to login</Box> : null}
      { alreadyRegistered ? <Box className="errorBox">Email has already been registered. Please click <Link to="/forgot-password">here</Link> to reset your password</Box> : null}
  </Box>
  )
}
export default Register